export default __webpack_public_path__ + "static/media/demo-03.9453ac69.gif";